import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import AddApplicantFields   from  '../Fragments/AddApplicantFields';
import SubmitInput          from '../Fields/SubmitInput';
import Field                from '../Field';
import { browserHistory }   from 'react-router';
import FullPageSpinner      from '../Fragments/FullPageSpinner';

let Quote = require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');

class AddGuarantor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showManualWarning: false,
            isFullPageSpinnerActive: false,
        };

        this.inputComponents = [];
    }

    componentWillMount() {
        // adding a guarantor is always a new landing page, so clear the cache
        window.localStorage.clear();

        let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if ( ! this.props.params.hash) {
            // No hash = error page
            browserHistory.push('/error/no-auth');
        } else {
            // Set the agent hash
            HttpService.setAgentHash(this.props.params.hash);
        }

        if ( ! this.props.params.applicationId || ! uuidFormat.test(this.props.params.applicationId)) {
            // No applicationId or not a uuid = error page
            browserHistory.push('/error/no-application');
        } else {
            // Application ID means we're adding a guarantor to an exiting Application
            window.localStorage.setItem('applicationId', this.props.params.applicationId);

            // Wipe any pre-existing data in BaseIndividualApplication
            window.localStorage.removeItem('BaseIndividualApplication');
            Quote.set('completionMethod', 3, 'BaseIndividualApplication');
        }

        // Set all the legal texts - inject relevant ones to the footer.
        HttpService.getPublicLegalTexts()
        .then(() => {
            document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
            document.getElementById('mainPhone').innerHTML = Quote.getByPath('domainInfo.generalTelephone');
        })
        .catch(error => {
            throw error;
        });
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    handleShowManualWarning(v) {
        if (v.toUpperCase() == "NO") {
            this.setState({
                showManualWarning: false,
            });
        } else if (v.toUpperCase() == "YES") {
            HttpService.createGuarantorRedirectToConnect();
        }
    }

    completeManually(e) {
        e.preventDefault();
        this.setState({
            showManualWarning: true,
        });
    }

    /**
     * POST the guarantor to an exiting Case
     */
    postGuarantor() {
        this.setState({ isFullPageSpinnerActive: true });
        this.inputComponents.concat(this.addApplicant.getChildInputComponents()).filter(value => {
            return (value !== null) && (value !== undefined) && (value.getChildInstance() !== null) && (value.getChildInstance() !== undefined);
        }).map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                HttpService.agentEmailToGuarantorProcess();
            }
        }, 1000);
    }

    render() {
        return(
            <div>
                <question-row class="header-row">
                    <h1>Details for guarantor</h1>
                </question-row>

                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <AddApplicantFields
                    type="guarantor"
                    source={'BaseIndividualApplication'}
                    agentStep={true}
                    ref={(instance) => {this.addApplicant = instance;}}
                />

                <SubmitInput
                    label={'Email to Guarantor'}
                    callbackFunction={this.postGuarantor.bind(this)}
                    backLink={false}
                    saveForLater={false}
                />

                <question-row class="no-border">
                    <div className="question-main">
                        <div className="question-top">
                            <a href="#" onClick={this.completeManually.bind(this)}>Or complete manually</a>
                        </div>
                        {this.state.showManualWarning ?
                            <div className="supplemental">
                                <div className="supplemental-bubble">
                                    <div className="arrow" />
                                    <p>Are you sure?</p>
                                    <p>By getting your guarantor to complete the form we get the information and the documentation we need much faster. You benefit from the following:</p>
                                    <ul>
                                        <li>Faster turnaround times</li>
                                        <li>Reduced involvement during the process</li>
                                        <li>Reduced contact from us</li>
                                        <li>Enhanced checks on your guarantor</li>
                                    </ul>
                                    <p>Do you want to continue to complete the form manually?</p>
                                    <Field
                                        hasBorder={false}
                                        hasPadding={false}
                                        question=""
                                        fieldName="continueToEnterManually"
                                        type="button-choice"
                                        callbackFunction={this.handleShowManualWarning.bind(this)}
                                        options={[
                                            {
                                                value: 'yes',
                                                text: 'Yes'
                                            },
                                            {
                                                value: 'no',
                                                text: 'No'
                                            }
                                        ]}
                                    />
                                </div>
                            </div>
                        : null}
                    </div>
                </question-row>
            </div>
        );
    }
}

AddGuarantor.propTypes = {
    params: PropTypes.object,
};

export default AddGuarantor;


// WEBPACK FOOTER //
// ./src/components/Screens/AddGuarantor.js